<template>
  <div>
    <div v-if="!mobile">
      <div class="content" v-if="order">
        <div class="container">
          <div class="checkout">
            <div class="checkout__wrapper checkout__wrapper--page">
              <div class="checkout__left">
                <div class="checkout__complete">
                  <div v-if="order.state == 'new'">
                    <div class="checkout__complete-title checkout__complete-title--waiting checkout__complete-title--orange">
                      Заказ {{order.foreign_number}} ожидает оплаты <i></i>
                    </div>
                    <div class="checkout__complete-text">Заказ необходимо оплатить в течение 30 минут</div>
                    <vue-ladda button-class="checkout__complete-pay button button--yellow" @click="redirectToPaymentPage" :loading="loadingGetPayLink" data-style="expand-right">Оплатить заказ</vue-ladda>
                    <div class="checkout__complete-link">
                      <div class="checkout__complete-link_title">Ссылка на страницу заказа</div>
                      <div class="checkout__complete-link_field">
                        <div class="checkout__complete-link_copy" @click="copyUrl()"></div>
                        <input type="text" disabled :value="orderUrl">
                      </div>
                    </div>
                  </div>
                  <div v-else-if="order.state == 'confirmation_pending'">
                    <div class="checkout__complete-title checkout__complete-title--waiting">
                      Заказ {{order.foreign_number}} ожидает подтверждения поставщиком <i></i>
                    </div>
                    <div class="checkout__complete-text">Время подтверждения: до 2 часов</div>
                    <div class="checkout__complete-link">
                      <div class="checkout__complete-link_title">Ссылка на страницу заказа</div>
                      <div class="checkout__complete-link_field">
                        <div class="checkout__complete-link_copy" @click="copyUrl()"></div>
                        <input type="text" disabled :value="orderUrl">
                      </div>
                    </div>
                  </div>
                  <div v-else-if="order.state == 'confirmed'">
                    <div class="checkout__complete-title checkout__complete-title--success">
                      Заказ {{order.foreign_number}} подтвержден <i></i>
                    </div>
                    <div class="checkout__complete-button">
                      <a :href="order.car_details.voucher_url" download class="button button--dark" target="_blank"><i></i>Скачать ваучер</a>
                    </div>
                  </div>
                  <div v-else>
                    <div class="checkout__complete-title checkout__complete-title--waiting checkout__complete-title--red">
                      Заказ отменен
                    </div>
                  </div>
                 <!--  <div class="app-ad" v-if="order.state !== 'rejected'">
                   <h3 class="app-ad__title">Управляй своими заказами</h3>
                   <div class="app-ad__text">Изменить заказы и отслеживать их статус теперь намного легче. Все есть в одном приложении.</div>
                   <div class="app-ad__links">
                     <a class="app-ad__link" href="#"><img src="../assets/img/appstore.svg" alt="appstore"></a>
                     <a class="app-ad__link" href="#"><img src="../assets/img/google-play.svg" alt="google play"></a>
                   </div>
                 </div> -->
                </div>
                <div class="checkout__price">
                  <div class="checkout__price-header">
                    <div class="checkout__price-title">Стоимость аренды</div>
                    <div class="checkout__price-sale" v-if="order.object_data.discount_percent">Скидка {{order.object_data.discount_percent}}%</div>
                  </div>
                  <div class="checkout__price-rows">
                    <div class="checkout__price-row">
                      <div class="checkout__price-row_title">За сутки</div>
                      <div class="checkout__price-row_value"><span v-if="order.object_data.rate_per_day_old">{{formatPrice(order.object_data.rate_per_day_old)}}</span> {{formatPrice(order.object_data.rate_per_day)}} <i class="rouble-sign">₽</i></div>
                    </div>
                    <div class="checkout__price-row">
                      <div class="checkout__price-row_title">За весь период ({{order.object_data.rent_period_days}} сут.)</div>
                      <div class="checkout__price-row_value"><span v-if="order.object_data.rate_subtotal_old">{{formatPrice(order.object_data.rate_subtotal_old)}}</span> {{formatPrice(order.object_data.rate_subtotal)}} <i class="rouble-sign">₽</i></div>
                    </div>
                    <div class="checkout__price-row" v-if="order.additional_data.extras.out_working_hours_fee > 0">
                      <div class="checkout__price-row_title">Обслуживание в нерабочее время</div>
                      <div class="checkout__price-row_value">{{formatPrice(order.additional_data.extras.out_working_hours_fee)}} <i class="rouble-sign">₽</i></div>
                    </div>
                  </div>
                </div>
                <div class="checkout__place">
                  <div class="checkout__place-box">
                    <div class="checkout__place-icon">
                      <img src="../assets/img/icons/mark.svg" alt="">
                    </div>
                    <div class="checkout__place-content">
                      <div class="checkout__place-title">
                        {{order.additional_data.info.pick_up_location.city_name_ru}}, <span>{{order.additional_data.info.pick_up_location.name}}</span>
                      </div>
                      <div class="checkout__place-rows">
                        <div class="checkout__place-row" v-if="order.additional_data.extras.pick_up_location_fee > 0">
                          <div class="checkout__place-row_title">Стоимость подачи</div>
                          <div class="checkout__place-row_value">{{order.additional_data.extras.pick_up_location_fee}} <i class="rouble-sign">₽</i></div>
                        </div>
                        <div class="checkout__place-row" v-if="order.additional_data.extras.airport_fee > 0">
                          <div class="checkout__place-row_title">Аэропортный сбор</div>
                          <div class="checkout__place-row_value">{{order.additional_data.extras.airport_fee}} <i class="rouble-sign">₽</i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="checkout__place-box">
                    <div class="checkout__place-icon">
                      <img src="../assets/img/icons/mark.svg" alt="">
                    </div>
                    <div class="checkout__place-content">
                      <div class="checkout__place-title">
                        {{order.additional_data.info.drop_off_location.city_name_ru}}, <span>{{order.additional_data.info.drop_off_location.name}}</span>
                      </div>
                      <div class="checkout__place-rows">
                        <div class="checkout__place-row" v-if="order.additional_data.extras.drop_off_location_fee > 0">
                          <div class="checkout__place-row_title">Стоимость возврата</div>
                          <div class="checkout__place-row_value">{{order.additional_data.extras.drop_off_location_fee}} <i class="rouble-sign">₽</i></div>
                        </div>
                        <div class="checkout__place-row" v-if="order.additional_data.extras.return_fee > 0">
                          <div class="checkout__place-row_title">Возврат между станциями</div>
                          <div class="checkout__place-row_value">{{order.additional_data.extras.return_fee}} <i class="rouble-sign">₽</i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="checkout__place-box">
                    <div class="checkout__place-icon">
                      <img src="../assets/img/icons/calendar.svg" alt="">
                    </div>
                    <div class="checkout__place-content">
                      <div class="checkout__place-date">
                        {{getDate(order.car_details.pick_up_datetime)}} <span>{{getHour(order.car_details.pick_up_datetime)}}</span> – {{getDate(order.car_details.drop_off_datetime)}} <span>{{getHour(order.car_details.drop_off_datetime)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="checkout__total">
                  <div class="checkout__total-row" v-if="eqPrtice > 0">
                    <div class="checkout__total-title">Стоимость доп. опций</div>
                    <div class="checkout__total-value">{{eqPrtice * order.additional_data.info.rent_period.rent_days}} <i class="rouble-sign">₽</i></div>
                  </div>
                  <div class="checkout__total-row">
                    <div class="checkout__total-title">Полная стоимость заказа</div>
                    <div class="checkout__total-value">{{formatPrice(order.cost)}} <i class="rouble-sign">₽</i></div>
                  </div>
                  <div class="checkout__total-row checkout__total-row--small" v-if="order.object_data.deposit > 0">
                    <div class="checkout__total-title">Депозит</div>
                    <div class="checkout__total-value">{{order.object_data.deposit}} <i class="rouble-sign">₽</i></div>
                  </div>
                  <div class="checkout__total-row" v-if="order.money_received > 0">
                    <div class="checkout__total-title">Оплачено</div>
                    <div class="checkout__total-value">{{formatPriceFloat(order.money_received)}} <i class="rouble-sign">₽</i></div>
                  </div>
                </div>
                <div class="checkout__personal">
                  <div class="checkout__personal-title">Личные данные</div>
                  <div class="checkout__personal-fields">
                    <div class="checkout__personal-field">
                      <div class="checkout__personal-label">Имя и фамилия</div>
                      <div class="checkout__personal-value">{{order.client_data.surname}} {{order.client_data.name}} {{order.client_data.middle_name}}</div>
                    </div>
                    <div class="checkout__personal-field">
                      <div class="checkout__personal-label">Телефон</div>
                      <div class="checkout__personal-value">{{order.client_data.phone}}</div>
                    </div>
                    <div class="checkout__personal-field">
                      <div class="checkout__personal-label">Электронная почта</div>
                      <div class="checkout__personal-value">{{order.client_data.email}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="checkout__right">
                <div class="checkout__title">
                  <div class="checkout__title-text">{{order.object_data.model}} <span v-if="order.object_data.year">({{order.object_data.year}})</span></div>
                </div>
                <div class="checkout__images checkout__images--large js-checkout-slider" v-if="order.object_data.car_model_thumbnail">
                  <div class="checkout__images-item">
                    <img :src="order.object_data.car_model_thumbnail" alt="">
                  </div>
                </div>
                <div class="checkout__info">
                  <div class="checkout__info-column">
                    <div class="checkout__info-item" v-if="order.object_data.seats">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/people.svg" alt=""></div>
                      <div class="checkout__info-title">Количество мест</div>
                      <div class="checkout__info-value">{{order.object_data.seats}}</div>
                    </div>
                    <div class="checkout__info-item" v-if="order.object_data.drive_type_name">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/drive.svg" alt=""></div>
                      <div class="checkout__info-title">Привод</div>
                      <div class="checkout__info-value">{{order.object_data.drive_type_name}}</div>
                    </div>
                    <div class="checkout__info-item" v-if="order.object_data.color">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/car.svg" alt=""></div>
                      <div class="checkout__info-title">Цвет</div>
                      <div class="checkout__info-value">{{order.object_data.color}}</div>
                    </div>
                    <div class="checkout__info-item" v-if="order.object_data.transmission_name">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/kpp.svg" alt=""></div>
                      <div class="checkout__info-title">КПП</div>
                      <div class="checkout__info-value">{{order.object_data.transmission_name}}</div>
                    </div>
                  </div>
                  <div class="checkout__info-column" v-if="order.object_data.conditioner">
                    <div class="checkout__info-item">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/snow.svg" alt=""></div>
                      <div class="checkout__info-title">{{order.object_data.conditioner}}</div>
                      <div class="checkout__info-value"></div>
                    </div>
                    <div class="checkout__info-item" v-if="order.object_data.fuel">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/fuel.svg" alt=""></div>
                      <div class="checkout__info-title">Топливо</div>
                      <div class="checkout__info-value">{{order.object_data.fuel}}</div>
                    </div>
                    <div class="checkout__info-item" v-if="order.object_data.doors">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/door.svg" alt=""></div>
                      <div class="checkout__info-title">Двери</div>
                      <div class="checkout__info-value">{{order.object_data.doors}}</div>
                    </div>
                    <div class="checkout__info-item" v-if="order.object_data.audio.length > 0">
                      <div class="checkout__info-icon"><img src="../assets/img/icons/sound.svg" alt=""></div>
                      <div class="checkout__info-title">Аудио</div>
                      <div class="checkout__info-value">{{order.object_data.audio.join(',')}}</div>
                    </div>
                  </div>
                </div>
                <div class="checkout__options" v-if="eqPrtice > 0">
                  <div class="checkout__options-title">Дополнительные опции</div>
                  <div class="checkout__options-rows">
                    <div class="checkout__options-row" v-for="e in order.additional_data.equipment">
                      <div class="checkout__options-control">
                        <div class="custom-control custom-checkbox custom-checkbox--black">
                          <input class="custom-control-input" type="checkbox" id="gps" checked disabled>
                          <label class="custom-control-label" for="gps">{{e.name}}</label>
                        </div>
                      </div>
                      <div class="checkout__options-price">
                        {{e.price}} <i class="rouble-sign">₽</i>/сут.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-order" v-else>
        <Loader />
      </div>
    </div>
    <div v-else>
      <div class="content" v-if="order">
        <div class="container">
          <div class="checkout">
            <div class="checkout__complete">
              <div v-if="order.state == 'new'">
                <div class="checkout__complete-title checkout__complete-title--waiting checkout__complete-title--orange">
                  <i></i> Заказ {{order.foreign_number}} ожидает оплаты
                </div>
                <div class="checkout__complete-text">Заказ необходимо оплатить в течение 30 минут</div>
                <vue-ladda button-class="checkout__complete-pay button button--yellow" @click="redirectToPaymentPage" :loading="loadingGetPayLink" data-style="expand-right">Оплатить заказ</vue-ladda>
                <div class="checkout__complete-link">
                  <div class="checkout__complete-link_title">Ссылка на страницу заказа</div>
                  <div class="checkout__complete-link_field">
                    <div class="checkout__complete-link_copy" @click="copyUrl()"></div>
                    <input type="text" disabled :value="orderUrl">
                  </div>
                </div>
              </div>
              <div v-else-if="order.state == 'confirmation_pending'">
                <div class="checkout__complete-title checkout__complete-title--waiting">
                  Заказ ожидает подтверждения поставщиком <i></i>
                </div>
                <div class="checkout__complete-text">Время подтверждения: до 2 часов</div>
                <div class="checkout__complete-link">
                  <div class="checkout__complete-link_title">Ссылка на страницу заказа</div>
                  <div class="checkout__complete-link_field">
                    <div class="checkout__complete-link_copy" @click="copyUrl()"></div>
                    <input type="text" disabled :value="orderUrl">
                  </div>
                </div>
              </div>
              <div v-else-if="order.state == 'confirmed'">
                <div class="checkout__complete-title checkout__complete-title--success">
                  Заказ подтвержден <i></i>
                </div>
                <div class="checkout__complete-button">
                  <a :href="order.car_details.voucher_url" download class="button button--dark" target="_blank"><i></i>Скачать ваучер</a>
                </div>
              </div>
              <div v-else>
                <div class="checkout__complete-title checkout__complete-title--waiting checkout__complete-title--red">
                  Заказ отменен
                </div>
              </div>
            </div>
            <br>
            <div class="checkout__title">
              <div class="checkout__title-text">{{order.object_data.model}} <span v-if="order.object_data.year">({{order.object_data.year}})</span></div>
            </div>
            <div class="checkout__images js-checkout-slider" v-if="order.object_data.car_model_thumbnail">
              <div class="checkout__images-item">
                <img :src="order.object_data.car_model_thumbnail" alt="">
              </div>
            </div>
            <div class="checkout__info">
              <div class="checkout__info-column">
                <div class="checkout__info-item" v-if="order.object_data.seats">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/people.svg" alt=""></div>
                  <div class="checkout__info-title">Количество мест</div>
                  <div class="checkout__info-value">{{order.object_data.seats}}</div>
                </div>
                <div class="checkout__info-item" v-if="order.object_data.drive_type_name">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/drive.svg" alt=""></div>
                  <div class="checkout__info-title">Привод</div>
                  <div class="checkout__info-value">{{order.object_data.drive_type_name}}</div>
                </div>
                <div class="checkout__info-item" v-if="order.object_data.color">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/car.svg" alt=""></div>
                  <div class="checkout__info-title">Цвет</div>
                  <div class="checkout__info-value">{{order.object_data.color}}</div>
                </div>
                <div class="checkout__info-item" v-if="order.object_data.transmission_name">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/kpp.svg" alt=""></div>
                  <div class="checkout__info-title">КПП</div>
                  <div class="checkout__info-value">{{order.object_data.transmission_name}}</div>
                </div>
              </div>
              <div class="checkout__info-column" v-if="order.object_data.conditioner">
                <div class="checkout__info-item">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/snow.svg" alt=""></div>
                  <div class="checkout__info-title">{{order.object_data.conditioner}}</div>
                  <div class="checkout__info-value"></div>
                </div>
                <div class="checkout__info-item" v-if="order.object_data.fuel">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/fuel.svg" alt=""></div>
                  <div class="checkout__info-title">Топливо</div>
                  <div class="checkout__info-value">{{order.object_data.fuel}}</div>
                </div>
                <div class="checkout__info-item" v-if="order.object_data.doors">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/door.svg" alt=""></div>
                  <div class="checkout__info-title">Двери</div>
                  <div class="checkout__info-value">{{order.object_data.doors}}</div>
                </div>
                <div class="checkout__info-item" v-if="order.object_data.audio.length > 0">
                  <div class="checkout__info-icon"><img src="../assets/img/icons/sound.svg" alt=""></div>
                  <div class="checkout__info-title">Аудио</div>
                  <div class="checkout__info-value">{{order.object_data.audio.join(',')}}</div>
                </div>
              </div>
            </div>
            <div class="checkout__options" v-if="eqPrtice > 0">
              <div class="checkout__options-title">Дополнительные опции</div>
              <div class="checkout__options-rows">
                <div class="checkout__options-row" v-for="e in order.additional_data.equipment">
                  <div class="checkout__options-control">
                    <div class="custom-control custom-checkbox custom-checkbox--black">
                      <input class="custom-control-input" type="checkbox" id="gps" checked disabled>
                      <label class="custom-control-label" for="gps">{{e.name}}</label>
                    </div>
                  </div>
                  <div class="checkout__options-price">
                    {{e.price}} <i class="rouble-sign">₽</i>/сут.
                  </div>
                </div>
              </div>
            </div>
            <div class="checkout__personal">
              <div class="checkout__personal-title">Личные данные</div>
              <div class="checkout__personal-field">
                <div class="checkout__personal-label">Имя и фамилия</div>
                <div class="checkout__personal-value">{{order.client_data.surname}} {{order.client_data.name}} {{order.client_data.middle_name}}</div>
              </div>
              <div class="checkout__personal-fields">
                <div class="checkout__personal-field">
                  <div class="checkout__personal-label">Телефон</div>
                  <div class="checkout__personal-value">{{order.client_data.phone}}</div>
                </div>
                <div class="checkout__personal-field">
                  <div class="checkout__personal-label">Электронная почта</div>
                  <div class="checkout__personal-value">{{order.client_data.email}}</div>
                </div>
              </div>
            </div>
            <div class="checkout__price">
              <div class="checkout__price-header">
                <div class="checkout__price-title">Стоимость аренды</div>
                <div class="checkout__price-sale" v-if="order.object_data.discount_percent">Скидка {{order.object_data.discount_percent}}%</div>
              </div>
              <div class="checkout__price-rows">
                <div class="checkout__price-row">
                  <div class="checkout__price-row_title">За сутки</div>
                  <div class="checkout__price-row_value"><span v-if="order.object_data.rate_per_day_old">{{formatPrice(order.object_data.rate_per_day_old)}}</span> {{formatPrice(order.object_data.rate_per_day)}} <i class="rouble-sign">₽</i></div>
                </div>
                <div class="checkout__price-row">
                  <div class="checkout__price-row_title">За весь период ({{order.object_data.rent_period_days}} сут.)</div>
                  <div class="checkout__price-row_value"><span v-if="order.object_data.rate_subtotal_old">{{formatPrice(order.object_data.rate_subtotal_old)}}</span> {{formatPrice(order.object_data.rate_subtotal)}} <i class="rouble-sign">₽</i></div>
                </div>
              </div>
            </div>
                <div class="checkout__place">
                  <div class="checkout__place-box">
                    <div class="checkout__place-icon">
                      <img src="../assets/img/icons/mark.svg" alt="">
                    </div>
                    <div class="checkout__place-content">
                      <div class="checkout__place-title">
                        {{order.additional_data.info.pick_up_location.city_name_ru}}, <span>{{order.additional_data.info.pick_up_location.name}}</span>
                      </div>
                      <div class="checkout__place-rows">
                        <div class="checkout__place-row">
                          <div class="checkout__place-row_title">Стоимость подачи</div>
                          <div class="checkout__place-row_value">{{order.additional_data.extras.pick_up_location_fee}} <i class="rouble-sign">₽</i></div>
                        </div>
                        <div class="checkout__place-row">
                          <div class="checkout__place-row_title">Аэропортный сбор</div>
                          <div class="checkout__place-row_value">{{order.additional_data.extras.airport_fee}} <i class="rouble-sign">₽</i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="checkout__place-box">
                    <div class="checkout__place-icon">
                      <img src="../assets/img/icons/mark.svg" alt="">
                    </div>
                    <div class="checkout__place-content">
                      <div class="checkout__place-title">
                        {{order.additional_data.info.drop_off_location.city_name_ru}}, <span>{{order.additional_data.info.drop_off_location.name}}</span>
                      </div>
                      <div class="checkout__place-rows">
                        <div class="checkout__place-row">
                          <div class="checkout__place-row_title">Стоимость возврата</div>
                          <div class="checkout__place-row_value">{{order.additional_data.extras.drop_off_location_fee}} <i class="rouble-sign">₽</i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="checkout__place-box">
                    <div class="checkout__place-icon">
                      <img src="../assets/img/icons/calendar.svg" alt="">
                    </div>
                    <div class="checkout__place-content">
                      <div class="checkout__place-date">
                        {{getDate(order.car_details.pick_up_datetime)}} <span>{{getHour(order.car_details.pick_up_datetime)}}</span> – {{getDate(order.car_details.drop_off_datetime)}} <span>{{getHour(order.car_details.drop_off_datetime)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
            <div class="checkout__total">
              <div class="checkout__total-row" v-if="eqPrtice > 0">
                <div class="checkout__total-title">Стоимость доп. опций</div>
                <div class="checkout__total-value">{{eqPrtice * order.additional_data.info.rent_period.rent_days}} <i class="rouble-sign">₽</i></div>
              </div>
              <div class="checkout__total-row">
                <div class="checkout__total-title">Полная стоимость заказа</div>
                <div class="checkout__total-value">{{formatPrice(order.cost)}} <i class="rouble-sign">₽</i></div>
              </div>
              <div class="checkout__total-row checkout__total-row--small" v-if="order.object_data.deposit > 0">
                <div class="checkout__total-title">Депозит</div>
                <div class="checkout__total-value">{{order.object_data.deposit}} <i class="rouble-sign">₽</i></div>
              </div>
              <div class="checkout__total-row">
                <div class="checkout__total-title">Оплачено</div>
                <div class="checkout__total-value">{{formatPriceFloat(order.money_received)}} <i class="rouble-sign">₽</i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-order" v-else>
        <Loader />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import VueLadda from 'vue-ladda';
import Loader from '@/components/Loader';

Vue.use(VueClipboard);
Vue.component('vue-ladda', VueLadda);

export default {
    name: 'Order',
    components: {
      Loader,
    },
    data() {
      return {
        mobile: false,
        width: 0,
        loadingGetPayLink: false,
      }
    },
    computed: {
      order() {
        return this.$store.getters.order;
      },
      eqPrtice() {
        return this.order.additional_data.equipment.reduce(function(prev, cur) {
          return parseInt(prev) + parseInt(cur.price);
        }, 0);
      },
      orderUrl() {
        return document.URL;
      },
    },
    methods: {
      copyUrl() {
        this.$copyText(this.orderUrl).then(function (e) {
          Vue.$toast.open({
            position: 'top-right',
            message: 'Ссылка успешно скопирована в буфер обмена',
            type: 'success',
          });
        }, function (e) {
          Vue.$toast.open({
            position: 'top-right',
            message: 'Ссылка не скопирована, попробуйте скопировать вручную',
            type: 'error',
          });
        })
      },
      redirectToPaymentPage() {
        this.loadingGetPayLink = true
        const parameters = {
          id: this.order.uuid,
          redirect_url: `${location.protocol}//${location.host}/order/${this.order.uuid}`,
        }
        this.$store.dispatch('getPayLink', parameters).then((resp) => {
          window.location.href = resp.data.payment_url;
        }).finally(() => this.loadingGetPayLink = false);
      },
      isMobile() {
        this.width = window.innerWidth;
        if( window.innerWidth <= 990 ) {
          this.mobile = true
        }
        else {
          this.mobile = false
        }
      },
      formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
      formatPriceFloat(price) {
        price = price.toFixed(2);
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
      getDate(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },
      getHour(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
      },
    },
    created() {
      this.isMobile();
      window.addEventListener("resize", this.isMobile);
    },
    destroyed() {
      window.removeEventListener("resize", this.isMobile);
    },
    mounted() {
      this.$store.dispatch('getOrder', this.$route.params.id);
      setInterval(() => {
        this.$store.dispatch('getOrder', this.$route.params.id);
      }, 15000);
    }
}
</script>

<style>
  .loading-order {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    height: calc(100vh - 120px);
    margin: auto;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    justify-content: center;
    -ms-align-items: center;
    align-items: center;
  }
  .checkout__complete-title--orange {
    color: #FF7800 !important;
  }
  .checkout__complete-title--orange i {
    background-image: url(../assets/img/icons/clock-orange.svg) !important;
  }
  .checkout__complete-pay {
    display: inline-flex !important;
    margin-top: 20px;
  }
  .checkout__complete-title--red {
    color: #EB5757 !important;
    margin-bottom: 20px !important;
  }
  .checkout__complete-link_copy {
    cursor: pointer;
  }
  .checkout__personal-value {
    word-wrap: break-word;
  }
  .checkout__complete {
    margin-bottom: 20px;
  }
  .checkout__complete-title {
    width: 160% !important;
  }
  @media screen and (max-width: 980px) {
    .checkout__complete-title {
      width: 100% !important;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
    }
    .checkout__complete-title i {
      top: 0;
      margin-left: 0;
      margin-right: 10px;
    }
    .checkout__complete-title {
      line-height: 28px !important;
      font-size: 26px !important;

    }
    .checkout__complete-title i {
      width: 64px !important;
      height: 64px !important;
    }
    .checkout__complete-title--success i {
      width: 20px !important;
      height: 20px !important;
    }
  }

</style>